<template>
  <div class="flex flex-col">
    <h2>Contabilidad</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="statusNavOptions" />

      <router-view class="flex-1 min-w-0 w-full" />
    </div>
  </div>
</template>

<script>
import StatusSideNav from "@/components/ui/StatusSideNav";
export default {
  name: "Accounting",

  components: {
    StatusSideNav,
  },

  computed: {
    statusNavOptions() {
      const incomeRoutes = ["incomesIndex", "incomesCreateForm", "incomesEditForm"];
      const expenseRoutes = ["expensesIndex", "expensesCreateForm", "expensesEditForm"];

      return [
        {
          label: "Ventas",
          icon: "💰",
          to: { name: "incomes" },
          active: incomeRoutes.includes(this.$route.name),
        },
        {
          label: "Egresos",
          icon: "🧾",
          to: { name: "expenses" },
          active: expenseRoutes.includes(this.$route.name),
        },
      ];
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "accounting");
  },
};
</script>
